import gql from 'graphql-tag';
import { query } from '../../client';
export const DEFAULT_PAYMENT_METHOD = gql `
  query DefaultPaymentMethodQuery($userId: String!) {
    defaultPaymentMethod(userId: $userId) @rest(type: "DefaultPaymentMethod", path: "payments/{args.userId}/default?include=billing_details&allowNotFound=true") {
      data @type(name: "PaymentMethod") {
        id
        card {
          brand
          last4
          exp_month
          exp_year
          fingerprint
        }
        billing_details {
          address {
            city
            country
            line1
            line2
            postal_code
            state
          }
          email
          name
          phone
        }
        provider
        customerId
        moneyPlatformToken
      }
    }
  }
`;
// Query default payment method from OMNI.
export function getDefaultPaymentMethod(userId) {
    return query({
        query: DEFAULT_PAYMENT_METHOD,
        variables: { userId },
    });
}
export default getDefaultPaymentMethod;
